module.exports = __webpack_public_path__ + "static/media/background-tipy.ac85bf8b.jpg";